const createDownloadableUrl = (content) => {
  const blob = new Blob([content], { type: 'text/csv' });
  return URL.createObjectURL(blob);
};

export default createDownloadableUrl;
